import { render, staticRenderFns } from "./SMSGateForm.vue?vue&type=template&id=2177398c&scoped=true"
import script from "./SMSGateForm.vue?vue&type=script&lang=js"
export * from "./SMSGateForm.vue?vue&type=script&lang=js"
import style0 from "./SMSGateForm.vue?vue&type=style&index=0&id=2177398c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2177398c",
  null
  
)

export default component.exports